<div class="settings-holder settings-active">
    <!-- Settings Connections Overview (First Level) (the items of the menu of Security)-->
    <div class="settings-holder-content content-active">
        <div class="settings-heading">
            <div class="d-md-none">
                <div class="heading-block">
                    <a class="nav-opener" href="#"
                        ><i class="icon icon-navigation" /></a
                    ><a class="nav-back" href="#">
                        <div class="ico-holder">
                            <i class="icon icon-chevron-left" />
                        </div>
                        <div class="ico-holder">
                            <i class="icon icon-connected" />
                        </div>
                        <div class="title-holder">
                            <strong class="settings-title"
                                >Connected accounts</strong
                            >
                        </div></a
                    >
                </div>
            </div>
            <div class="d-none d-md-block">
                <div class="heading-block">
                    <h1 class="h6 settings-title">Connected accounts</h1>
                </div>
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="content-block">
                        <h3 class="title-card-block text-white">Contacts</h3>
                        <div class="intro-text text-small">
                            <p>
                                Your contacts are used to help yout to find and
                                invite friends and colleagues
                            </p>
                        </div>
                        <div
                            class="card-settings-main card bg-transparent-mobile"
                        >
                            <div class="card-body">
                                <nav>
                                    <ul class="nav-second-level nav-settings">
                                        <li>
                                            <a
                                                class="opener-third-level"
                                                href="#"
                                            >
                                                <div class="df-row df-aic gx-2">
                                                    <div class="col-auto">
                                                        <span
                                                            class="ico-holder has-bg"
                                                            ><img
                                                                src="../account/images/avatar-google.svg"
                                                                alt="Google"
                                                                width="22"
                                                                height="22"
                                                            /></span
                                                        >
                                                    </div>
                                                    <div class="col">
                                                        <div
                                                            class="opener-text"
                                                        >
                                                            <div
                                                                class="df-row df-jcb df-aic"
                                                            >
                                                                <div
                                                                    class="col"
                                                                >
                                                                    <strong
                                                                        class="nav-title"
                                                                        >Google</strong
                                                                    >
                                                                    <div
                                                                        class="nav-text"
                                                                    >
                                                                        <p>
                                                                            Google
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-auto"
                                                                >
                                                                    <i
                                                                        class="icon icon-chevron-right"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div></a
                                            >
                                        </li>
                                        <li>
                                            <div class="opener-third-level">
                                                <div class="df-row df-aic gx-2">
                                                    <div class="col-auto">
                                                        <span
                                                            class="ico-holder has-bg"
                                                            ><img
                                                                src="../account/images/avatar-microsoft.svg"
                                                                alt="Microsoft"
                                                                width="15"
                                                                height="15"
                                                            /></span
                                                        >
                                                    </div>
                                                    <div class="col">
                                                        <div
                                                            class="opener-text"
                                                        >
                                                            <div
                                                                class="df-row df-jcb df-aic"
                                                            >
                                                                <div
                                                                    class="col"
                                                                >
                                                                    <strong
                                                                        class="nav-title"
                                                                        >Microsoft</strong
                                                                    >
                                                                    <div
                                                                        class="nav-text"
                                                                    >
                                                                        <p>
                                                                            Microsoft
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-auto"
                                                                >
                                                                    <a
                                                                        class="btn btn-primary"
                                                                        href="#"
                                                                        >Connect</a
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div class="content-block">
                        <h3 class="title-card-block text-white">
                            Integrations
                        </h3>
                        <div class="intro-text text-small">
                            <p>
                                These Aaps that can view and make changes to
                                your Vollume content while using these apps
                                outside of Vollume. If you don’t recognize an
                                app, disconnect it
                            </p>
                        </div>
                        <div
                            class="card-settings-main card bg-transparent-mobile"
                        >
                            <div class="card-body">
                                <nav>
                                    <ul class="nav-second-level nav-settings">
                                        <li>
                                            <div class="opener-third-level">
                                                <div class="df-row df-aic gx-2">
                                                    <div class="col-auto">
                                                        <span
                                                            class="ico-holder has-bg"
                                                            ><img
                                                                src="../account/images/avatar-slack-new.svg"
                                                                alt="Slack"
                                                                width="18"
                                                                height="18"
                                                            /></span
                                                        >
                                                    </div>
                                                    <div class="col">
                                                        <div
                                                            class="opener-text"
                                                        >
                                                            <div
                                                                class="df-row df-jcb df-aic"
                                                            >
                                                                <div
                                                                    class="col"
                                                                >
                                                                    <strong
                                                                        class="nav-title"
                                                                        >Slack</strong
                                                                    >
                                                                    <div
                                                                        class="nav-text"
                                                                    >
                                                                        <p>
                                                                            Slack
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-auto"
                                                                >
                                                                    <a
                                                                        class="btn btn-primary"
                                                                        href="#"
                                                                        >Connect</a
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="opener-third-level">
                                                <div class="df-row df-aic gx-2">
                                                    <div class="col-auto">
                                                        <span
                                                            class="ico-holder has-bg"
                                                            ><img
                                                                src="../account/images/avatar-ableton.svg"
                                                                alt="Ableton"
                                                                width="18"
                                                                height="8"
                                                            /></span
                                                        >
                                                    </div>
                                                    <div class="col">
                                                        <div
                                                            class="opener-text"
                                                        >
                                                            <div
                                                                class="df-row df-jcb df-aic"
                                                            >
                                                                <div
                                                                    class="col"
                                                                >
                                                                    <strong
                                                                        class="nav-title"
                                                                        >Ableton
                                                                        Live</strong
                                                                    >
                                                                    <div
                                                                        class="nav-text"
                                                                    >
                                                                        <p>
                                                                            Ableton
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-auto"
                                                                >
                                                                    <a
                                                                        class="btn btn-primary"
                                                                        href="#"
                                                                        >Connect</a
                                                                    >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <a
                                                class="opener-third-level"
                                                href="#"
                                            >
                                                <div class="df-row df-aic gx-2">
                                                    <div class="col-auto">
                                                        <span
                                                            class="ico-holder has-bg"
                                                            ><img
                                                                src="../account/images/avatar-figma.svg"
                                                                alt="Figma"
                                                                width="11"
                                                                height="16"
                                                            /></span
                                                        >
                                                    </div>
                                                    <div class="col">
                                                        <div
                                                            class="opener-text"
                                                        >
                                                            <div
                                                                class="df-row df-jcb df-aic"
                                                            >
                                                                <div
                                                                    class="col"
                                                                >
                                                                    <strong
                                                                        class="nav-title"
                                                                        >Figma</strong
                                                                    >
                                                                    <div
                                                                        class="nav-text"
                                                                    >
                                                                        <p>
                                                                            Figma
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="col-auto"
                                                                >
                                                                    <i
                                                                        class="icon icon-chevron-right"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div></a
                                            >
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Settings Connections Details (Second Level)-->
    <div class="settings-holder-content">
        <div class="settings-heading">
            <div class="heading-block">
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title"
                            >Connected account details</strong
                        >
                    </div></a
                >
            </div>
        </div>
        <div class="settings-content">
            <div class="settings-content-holder">
                <div class="card-h-100">
                    <div class="card-details card-join-bottom card">
                        <div class="card-body">
                            <div class="device-ico-holder">
                                <div class="ico-holder has-bg">
                                    <img
                                        src="images/avatar-google.svg"
                                        alt="Apple"
                                        width="50"
                                        height="50"
                                    />
                                </div>
                            </div>
                            <strong class="h5 card-title">Google</strong>
                            <dl class="list-details">
                                <dt>Google</dt>
                                <dd />
                            </dl>
                            <dl class="list-details">
                                <dt>Connected</dt>
                                <dd>
                                    <time
                                        class="time-activity"
                                        datetime="2020-08-02">2 Aug, 2020</time
                                    >
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
                <div
                    class="card-settings-main-footer card bg-transparent-mobile"
                >
                    <div class="card-body">
                        <div class="df-row df-aic row-mobile-reverse gx-1">
                            <div class="col">
                                <p>
                                    You will be logged out from <span
                                        class="text-white">Google</span
                                    >
                                </p>
                            </div>
                            <div class="col-md-auto">
                                <a class="btn btn-danger" href="#"
                                    >Disconnect Device</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
